import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiMsService, ApiMsServices } from '../_core/services/api-ms.service';
import { GlobalService } from '../_core/services/global.service';
import { UserRequestPermissionModel } from '../user/user-create-edit/models/user-request-permission.model';

@Injectable()
export class RequestPermissionService extends GlobalService {
  constructor(
    protected _http: HttpClient,
    private readonly apiMsService: ApiMsService
  ) {
    super(_http);
  }

  public getWritePoPermissions() {
    return this.getPermissions(false, true, false, false, true);
  }

  public getWritePePermissions() {
    return this.getPermissions(false, true, false, true, false);
  }

  public getCreatePoPermissions() {
    return this.getPermissions(true, false, false, false, true);
  }

  public getCreatePePermissions() {
    return this.getPermissions(true, false, false, true, false);
  }

  public getReadPoPermissions() {
    return this.getPermissions(false, false, true, false, true);
  }

  public getReadPePermissions() {
    return this.getPermissions(false, false, true, true, false);
  }

  public getPePermissions() {
    return this.getPermissions(true, true, true, true, false);
  }

  public getPoPermissions() {
    return this.getPermissions(true, true, true, false, true);
  }

  public getPoAndPePermissions() {
    return forkJoin(this.getPoPermissions(), this.getPePermissions());
  }

  public getPoAndPeWritePermissions() {
    return forkJoin(this.getWritePoPermissions(), this.getWritePePermissions());
  }

  public getPoCreateAndWritePermissions() {
    return forkJoin(this.getCreatePoPermissions(), this.getWritePoPermissions());
  }

  public getPeCreateAndWritePermissions() {
    return forkJoin(this.getCreatePePermissions(), this.getWritePePermissions());
  }

  private getPermissions(create?, write?, read?, pe?, po?) {
    const args = {
      entity: 'Request',
      queryname: 'getRequestPermissionsByType',
      createPer: '',
      readPer: '',
      writePer: '',
    };

    if (create) {
      if (pe) {
        args['createPer'] = 'request_create_pe%';
      } else if (po) {
        args['createPer'] = 'request_create_po%';
      } else {
        args['createPer'] = 'request_create%';
      }
    }

    if (read) {
      if (pe) {
        args['readPer'] = 'request_read_pe%';
      } else if (po) {
        args['readPer'] = 'request_read_po%';
      } else {
        args['readPer'] = 'request_read%';
      }
    }

    if (write) {
      if (pe) {
        args['writePer'] = 'request_write_pe%';
      } else if (po) {
        args['writePer'] = 'request_write_po%';
      } else {
        args['writePer'] = 'request_write%';
      }
    }

    return this.callServicePost('defaultGet', args, {}).pipe(
      map((data) => {
        if (data.Success && data.Result.Collection.length > 0) {
          const permissions = [];
          data.Result.Collection.forEach((element) => {
            permissions.push(element.permissionName);
          });

          return permissions;
        }

        return [];
      })
    );
  }

  public getRequestPermissions(areaUniqueCode: string = null): Observable<UserRequestPermissionModel[]> {
    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, `permission/get-list`, {
      filters: { areaUniqueCode },
    });
  }
}
